var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "signin_enter" },
    [
      _vm.attendType.indexOf("3") > -1
        ? _c("div", { staticClass: "face_box_qrcode" }, [
            _c("img", {
              staticClass: "qrcode_img",
              attrs: { src: _vm.qrCodeImgUrl, alt: "" },
            }),
          ])
        : _c("div", { staticClass: "face_box" }, [
            _vm.attendType.indexOf("2") > -1
              ? _c("p", { staticClass: "face_text" }, [
                  _vm._v("摄像头实时拍摄的人脸画面"),
                ])
              : _c("div", { staticClass: "jsk_state" }, [
                  _c("p", { staticClass: "qsk_text" }, [_vm._v("请刷卡")]),
                  _c("img", {
                    attrs: {
                      src: require("../../../../../public/img/product/bootScreen/img-swipe.png"),
                    },
                  }),
                ]),
          ]),
      _c("div", { staticClass: "signin_state" }, [
        _c(
          "div",
          { staticClass: "head_img" },
          [
            _vm.attendInfo.errorCode && _vm.attendInfo.errorCode < 30004
              ? _c("van-image", {
                  staticClass: "header_mainimg",
                  attrs: {
                    "lazy-load": "",
                    src: _vm._f("imgFormat")(_vm.attendInfo.photo),
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "loading",
                        fn: function () {
                          return [
                            _c("van-loading", {
                              attrs: { type: "spinner", size: "20" },
                            }),
                          ]
                        },
                        proxy: true,
                      },
                      {
                        key: "error",
                        fn: function () {
                          return [
                            _c("img", {
                              staticClass: "header_errorimg",
                              attrs: { src: _vm.defaultImg },
                            }),
                          ]
                        },
                        proxy: true,
                      },
                    ],
                    null,
                    false,
                    4251430787
                  ),
                })
              : _c("img", { attrs: { src: _vm.defaultImg } }),
          ],
          1
        ),
        _c("div", { staticClass: "state_box" }, [
          _vm.attendInfo.errorCode == 30001
            ? _c("div", [
                _c("p", { staticClass: "succe" }, [_vm._v("签到成功")]),
                _c("p", { staticClass: "name" }, [
                  _vm._v(_vm._s(_vm.attendInfo.name)),
                ]),
              ])
            : _vm.attendInfo.errorCode == 30002
            ? _c("div", [
                _c("p", { staticClass: "error" }, [_vm._v("重复签到")]),
                _c("p", { staticClass: "name" }, [
                  _vm._v(_vm._s(_vm.attendInfo.name)),
                ]),
              ])
            : _vm.attendInfo.errorCode == 30003
            ? _c("div", [
                _c("p", { staticClass: "error" }, [_vm._v("重复签退")]),
                _c("p", { staticClass: "name" }, [
                  _vm._v(_vm._s(_vm.attendInfo.name)),
                ]),
              ])
            : _vm.attendInfo.errorCode == 30005
            ? _c("div", [_c("p", { staticClass: "error" }, [_vm._v("无效卡")])])
            : _c("span", { staticClass: "wqd" }, [
                _vm._v("请你人脸识别签到或刷卡签到！"),
              ]),
        ]),
      ]),
      _c(
        "van-dialog",
        {
          attrs: {
            "show-confirm-button": false,
            closeOnClickOverlay: "",
            "show-cancel-button": false,
            width: "85%",
          },
          model: {
            value: _vm.show,
            callback: function ($$v) {
              _vm.show = $$v
            },
            expression: "show",
          },
        },
        [
          _c(
            "div",
            {
              staticClass: "dialog-signin-maindiv",
              on: {
                click: function ($event) {
                  _vm.show = false
                },
              },
            },
            [
              _c("div", { staticClass: "dialog-closebuttondiv" }, [
                _vm._v("点击任意处关闭"),
              ]),
              _c("div", {
                staticClass: "dialog-closebutton iconfont icon-icon_wrong",
                on: {
                  click: function ($event) {
                    _vm.show = false
                  },
                },
              }),
              _c("div", { staticClass: "dialog-maininfo" }, [
                _c("div", { staticClass: "maininfo_mess" }, [
                  _c("div", { staticClass: "maininfo_mess_imgcontent" }, [
                    _c("img", {
                      attrs: {
                        src: require("../../../../../public/img/product/bootScreen/icon-alert.png"),
                      },
                    }),
                  ]),
                  _c("p", { staticClass: "go_place" }, [
                    _vm._v(" " + _vm._s(_vm.attendInfo.name || "") + "学员"),
                    _c("br"),
                    _vm._v("请您前往"),
                    _c("span", [_vm._v(_vm._s(_vm.addressInfo.place || ""))]),
                    _vm._v("签到！ "),
                  ]),
                  _c("p", { staticClass: "now_place" }, [
                    _vm._v("当前位置：" + _vm._s(_vm.currentAddress || "")),
                  ]),
                ]),
                _c("div", { staticClass: "course_mess" }, [
                  _c("p", { staticClass: "course_title" }, [
                    _vm._v("您的课程信息如下："),
                  ]),
                  _c("div", { staticClass: "course_item" }, [
                    _c("p", { staticClass: "course_label iconfont icon-rili" }),
                    _c("p", { staticClass: "course_val" }, [
                      _vm._v(
                        _vm._s(
                          _vm.dsf.date.format(
                            _vm.addressInfo.beginDateTime,
                            "mm月dd日 hh:ii"
                          )
                        )
                      ),
                    ]),
                  ]),
                  _c("div", { staticClass: "course_item" }, [
                    _c("p", {
                      staticClass: "course_label iconfont icon-address",
                    }),
                    _c("p", { staticClass: "course_val" }, [
                      _vm._v(_vm._s(_vm.addressInfo.place || "")),
                    ]),
                  ]),
                  _c("div", { staticClass: "course_item" }, [
                    _c("p", { staticClass: "course_label iconfont icon-xxkc" }),
                    _c("p", { staticClass: "course_val" }, [
                      _vm._v(" " + _vm._s(_vm.addressInfo.name || "") + " "),
                    ]),
                  ]),
                  _c("div", { staticClass: "course_item" }, [
                    _c("p", {
                      staticClass: "course_label iconfont icon-jiaoshi",
                    }),
                    _c("p", { staticClass: "course_val" }, [
                      _vm._v(_vm._s(_vm.addressInfo.speakerText || "")),
                    ]),
                  ]),
                ]),
              ]),
            ]
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }